import React from 'react';
import { Loader2 } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  isLoading?: boolean;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
}
export function Button({
  children,
  className = '',
  variant = 'primary',
  size = 'md',
  isLoading = false,
  leftIcon,
  rightIcon,
  disabled,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-lg font-medium transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed';
  const variants = {
    primary: 'bg-[#FF5722] text-white hover:bg-[#F4511E] focus:ring-[#FF5722] shadow-lg shadow-orange-900/20',
    secondary: 'bg-[#1E293B] text-white hover:bg-[#334155] focus:ring-[#1E293B]',
    outline: 'border border-[#334155] text-white hover:border-[#FF5722] hover:text-[#FF5722] bg-transparent',
    ghost: 'text-[#94A3B8] hover:text-white hover:bg-[#1E293B]/50'
  };
  const sizes = {
    sm: 'px-3 py-1.5 text-sm',
    md: 'px-5 py-2.5 text-base',
    lg: 'px-8 py-3.5 text-lg'
  };
  return <button className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} disabled={disabled || isLoading} {...props} data-id="element-295" data-mp="tnoom86ax0ti">
      {isLoading && <Loader2 className="mr-2 h-4 w-4 animate-spin" data-id="element-296" data-mp="12n3hfe9xxnh6" />}
      {!isLoading && leftIcon && <span className="mr-2" data-id="element-297" data-mp="xos3osgiysto">{leftIcon}</span>}
      {children}
      {!isLoading && rightIcon && <span className="ml-2" data-id="element-298" data-mp="1cdesrlvyeyy3">{rightIcon}</span>}
    </button>;
}